<template>
  <v-expansion-panels>

    <v-expansion-panel key="0">
      <v-expansion-panel-header>
        <h5 class="text-center align-middle fs-4 mb-0">Tutarlar</h5>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="mb-5">
        <div class="container-xxl-fluid">
          <div class="row">
            <div class="col-lg-3">
              <ToplamStokTutari></ToplamStokTutari>
            </div>
            <div class="col-lg-3">
              <ToplamTedarikci></ToplamTedarikci>
            </div>
            <div class="col-lg-3">
              <ToplamB2BSiparisTutari></ToplamB2BSiparisTutari>
            </div>
            <div class="col-lg-3">
              <ToplamB2BMusteriSayisi></ToplamB2BMusteriSayisi>
            </div>
            <div class="col-lg-3">
              <ToplamB2BSiparisSayisi></ToplamB2BSiparisSayisi>
            </div>
            <div class="col-lg-3">
              <ToplamERPSiparisTutari></ToplamERPSiparisTutari>
            </div>
            <div class="col-lg-3">
              <ToplamERPMusteriSayisi></ToplamERPMusteriSayisi>
            </div>
            <div class="col-lg-3">
              <ToplamERPSiparisSayisi></ToplamERPSiparisSayisi>
            </div>
            <div class="col-lg-3">
              <ToplamBekleyenSiparisTutari></ToplamBekleyenSiparisTutari>
            </div>
<!--            <div class="col-lg-3">-->
<!--              <ToplamTeklifSayisi></ToplamTeklifSayisi>-->
<!--            </div>-->
            <div class="col-lg-3">
              <ToplamTeklifSatisTutari></ToplamTeklifSatisTutari>
            </div>
            <div class="col-lg-3">
              <ToplamAlacakTutari></ToplamAlacakTutari>
            </div>
            <div class="col-lg-3">
              <ToplamBorcTutari></ToplamBorcTutari>
            </div>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>

import ToplamStokTutari from "@/components/dashboard/ToplamStokTutarı/ToplamStokTutari";
import ToplamTedarikci from "@/components/dashboard/ToplamTedarikci/ToplamTedarikci";
import ToplamB2BSiparisTutari from "@/components/dashboard/ToplamB2BSiparisTutari/ToplamB2BSiparisTutari";
import ToplamB2BMusteriSayisi from "@/components/dashboard/ToplamB2BMusteriSayisi/ToplamB2BMusteriSayisi";
import ToplamB2BSiparisSayisi from "@/components/dashboard/ToplamB2BSiparisSayisi/ToplamB2BSiparisSayisi";
import ToplamERPSiparisTutari from "@/components/dashboard/ToplamERPSiparisTutari/ToplamERPSiparisTutari";
import ToplamERPMusteriSayisi from "@/components/dashboard/ToplamERPMusteriSayisi/ToplamERPMusteriSayisi";
import ToplamERPSiparisSayisi from "@/components/dashboard/ToplamERPSiparisSayisi/ToplamERPSiparisSayisi";
// import ToplamTeklifSayisi from "@/components/dashboard/ToplamTeklifSayisi/ToplamTeklifSayisi";
import ToplamTeklifSatisTutari from "@/components/dashboard/ToplamTeklifSatışTutarı/ToplamTeklifSatisTutari";
import ToplamAlacakTutari from "@/components/dashboard/ToplamAlacakTutari/ToplamAlacakTutari";
import ToplamBorcTutari from "@/components/dashboard/ToplamBorcTutari/ToplamBorcTutari";
import {mapActions, mapState} from "vuex";
import ToplamBekleyenSiparisTutari from "@/components/dashboard/ToplamBekleyenSiparisTutari/ToplamBekleyenSiparisTutari.vue";

export default {
  name: "ReportCompanyDataContainer",
  components: {
    ToplamBekleyenSiparisTutari,
    ToplamStokTutari,
    ToplamTedarikci,
    ToplamB2BSiparisTutari,
    ToplamB2BMusteriSayisi,
    ToplamB2BSiparisSayisi,
    ToplamERPSiparisTutari,
    ToplamERPMusteriSayisi,
    ToplamERPSiparisSayisi,
    // ToplamTeklifSayisi,
    ToplamTeklifSatisTutari,
    ToplamAlacakTutari,
    ToplamBorcTutari
  },
  props: {
    dashboardFilterCurrentCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterSalesPersonCodeProp: {
      type: String,
      default: null
    },
    dashboardFilterReportDbNameProp: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapState("auth", ["user"])
  },
  mounted() {
    this._fetchCompanyTotalInfoReport();
    this._fetchStockDetailReport();
  },
  methods: {
    ...mapActions("currencies", ["setDollar", "setEuro", "setPound"]),
    ...mapActions("dashboard", [
      "fetchCompanyTotalInfoReport",
      "fetchStockDetailReport"
    ]),
    _fetchCompanyTotalInfoReport() {
      this.reportCompanyDataLoading = true;
      this.fetchCompanyTotalInfoReport({
        params: {
          userId: this.user.UserId,
          ...(!(this.dashboardFilterCurrentCodeProp === "" || this.dashboardFilterCurrentCodeProp == null)) && {currentCode: this.dashboardFilterCurrentCodeProp},
          ...(!(this.dashboardFilterSalesPersonCodeProp === "" || this.dashboardFilterSalesPersonCodeProp == null)) && {salesPersonCode: this.dashboardFilterSalesPersonCodeProp},
          ...(!(this.dashboardFilterReportDbNameProp === "" || this.dashboardFilterReportDbNameProp == null)) && {reportDbName: this.dashboardFilterReportDbNameProp}
        },
        body: {}
      }).then((result) => {
        if (result && result.data.success) {
          this.reportCompanyData = result.data.data;
          this.setDollar(result.data.data.dollar);
          this.setEuro(result.data.data.euro);
          this.setPound(result.data.data.pound);
        }
        this.reportCompanyDataLoading = false;
      })
    },
    _fetchStockDetailReport() {
      this.stockDetailDataLoading = true;
      this.fetchStockDetailReport({
        params: {
          ...(!(this.dashboardFilterReportDbName === "" || this.dashboardFilterReportDbName == null)) && {reportDbName: this.dashboardFilterReportDbName}
        },
        body: {}
      }).then((result) => {
        if (result.data.success)
          this.stockDetailData = result.data.data;
        this.stockDetailDataLoading = false;
      })
    },
  },
  watch: {
    dashboardFilterCurrentCodeProp(newVal) {
      newVal;
      this._fetchCompanyTotalInfoReport()
      this._fetchStockDetailReport()
    },
    dashboardFilterSalesPersonCodeProp(newVal) {
      newVal;
      this._fetchCompanyTotalInfoReport()
      this._fetchStockDetailReport()
    },
    dashboardFilterReportDbNameProp(newVal) {
      newVal;
      this._fetchCompanyTotalInfoReport()
      this._fetchStockDetailReport()
    }

  }
}
</script>

<style scoped>

</style>